import React, { useState } from 'react';
import HeroAccordion, { HeroStrip } from './HeroAccordion';

const strips: HeroStrip[] = [
  {
    id: 'signage',
    label: 'Signage',
    blurb: 'From off-the-shelf panels to fully custom fabricated signs.',
    to: '/services/all-signage',
    image: '/home/hero/signage.jpg',
  },
  {
    id: 'vehicles',
    label: 'Vehicles',
    blurb: 'Turn up to your next job looking professional, on-brand and, most importantly, get noticed by potential customers.',
    to: '/services/vehicle-signwriting',
    image: '/home/van.jpg',
    mono: true,
  },
  {
    id: 'clothing',
    label: 'Clothing',
    blurb: 'Premium garments and customisation, all in one place.',
    to: '/clothing',
    image: '/home/hero/clothing.jpg',
  },
  {
    id: 'display',
    label: 'Display',
    blurb: 'Brand your space and bring every event to life.',
    to: '/services/all-display',
    image: '/home/display/oc-flag.jpg',
  },
  {
    id: 'printing',
    label: 'Printing',
    blurb: 'Bring your artwork to life with high-quality, vibrant prints.',
    to: '/printing',
    image: '/home/hero/printing.jpg',
  },
];

const HomeHero: React.FC = () => {
  const [paused, setPaused] = useState(false);

  const scrollToWork = () => {
    document.querySelector('#our-work')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative bg-black text-white overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] lg:h-[calc(60svh_-_var(--header-h,0px))] lg:min-h-[520px]">
        {/* Left: photo + headline */}
        <div className="relative min-h-[320px] sm:min-h-[400px] lg:min-h-0 flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover will-change-[filter,transform] motion-reduce:transition-none"
            style={{
              backgroundImage: 'url(/home/van.jpg)',
              backgroundPosition: '70% 40%',
              filter: paused ? 'grayscale(1) brightness(0.55)' : 'grayscale(0) brightness(1)',
              transform: paused ? 'scale(1.03)' : 'scale(1)',
              transition: 'filter 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 900ms cubic-bezier(0.22, 1, 0.36, 1)',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-black/10" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />

          <div className="relative z-10 w-full px-6 lg:px-16 xl:px-24 py-10 sm:py-16 lg:py-10 text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-5 mb-3 lg:mb-5">
              <span className="hidden lg:block h-px w-12 bg-[#78BE20]" />
              <span className="font-poppins text-[11px] md:text-xs font-semibold tracking-[0.25em] uppercase">
                Customisation Specialists
              </span>
            </div>

            <h1 className="font-montserrat font-extrabold leading-[1.02] tracking-[-0.03em] text-[clamp(30px,4.4vw,72px)] max-w-2xl mx-auto lg:mx-0">
              Make the right
              <br />
              <span className="text-[#78BE20]">first impression.</span>
            </h1>

            <p className="font-poppins text-base md:text-xl mt-3 lg:mt-5">That&apos;s where we come in.</p>
            <p className="font-poppins text-[13px] md:text-base text-white/70 mt-1 lg:mt-1.5 max-w-xl mx-auto lg:mx-0">
              We focus on quality, consistency and straightforward service to promote your business
              and brand your space.
            </p>

            <button
              type="button"
              onClick={scrollToWork}
              className="mt-5 lg:mt-7 inline-block font-poppins text-[11px] font-semibold tracking-[0.15em] uppercase border border-white/70 px-8 py-4 transition-colors duration-300 hover:bg-[#78BE20] hover:border-[#78BE20]"
            >
              See our work
            </button>
          </div>
        </div>

        {/* Right: torn service strips */}
        <div className="relative h-[540px] sm:h-[640px] lg:h-auto">
          <HeroAccordion strips={strips} onActiveChange={setPaused} className="lg:absolute lg:inset-0" />
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
